import React from "react";
import "./TabBar.css";

export type TabType = "code" | "diagram";

interface TabBarProps {
    activeTab: TabType;
    onTabChange: (tab: TabType) => void;
    darkMode?: boolean;
    diagramCollaborationOn?: boolean;
    onDiagramCollaborationToggle?: () => void;
}

const TabBar: React.FC<TabBarProps> = ({
    activeTab,
    onTabChange,
    darkMode,
    diagramCollaborationOn = false,
    onDiagramCollaborationToggle
}) => {
    return (
        <div className={`tab-bar${darkMode ? " tab-bar-dark" : ""}`}>
            <div className="tab-bar-inner">
                <button
                    className={`tab-btn${activeTab === "code" ? " tab-btn-active" : ""}`}
                    onClick={() => onTabChange("code")}
                    aria-selected={activeTab === "code"}
                    role="tab"
                >
                    <span className="tab-icon">&lt;/&gt;</span>
                    <span className="tab-label">Code</span>
                </button>
                <button
                    className={`tab-btn${activeTab === "diagram" ? " tab-btn-active" : ""}`}
                    onClick={() => onTabChange("diagram")}
                    aria-selected={activeTab === "diagram"}
                    role="tab"
                >
                    <span className="tab-icon">◇</span>
                    <span className="tab-label">Diagram</span>
                </button>
                {onDiagramCollaborationToggle && activeTab === "diagram" && (
                    <button
                        className={`tab-btn tab-btn-collab${diagramCollaborationOn ? " tab-btn-collab-on" : ""}`}
                        onClick={onDiagramCollaborationToggle}
                        title={diagramCollaborationOn ? "Live collaboration on – click to turn off" : "Turn on live collaboration (diagram pointers)"}
                    >
                        <span className="tab-icon">●</span>
                        <span className="tab-label">Live</span>
                    </button>
                )}
            </div>
        </div>
    );
};

export default TabBar;
